import { get, isString, flatten } from 'lodash'

export const CREDIT_SAVE_FAILED = "We couldn't save this credit. Your entry is still here. Check it and click + again."

const FIELD_LABELS = { name: 'Name', type: 'Type', url: 'Website', email: 'Email', instagram: 'Instagram' }

// Django reports credit validation errors as a field map, e.g.
// { name: ['Ensure this field has no more than 128 characters.'] } -- those are
// written for people, so show them labelled by field. Anything else (a `detail`
// string such as an auth message, HTML, or an unknown shape) is server-speak and
// is never shown to vendors; they get the generic message instead.
function fieldMessages (error) {
  const data = get(error, 'response.data')
  if (!data || isString(data) || data.detail) return null
  const messages = []
  Object.keys(data).forEach((field) => {
    const label = FIELD_LABELS[field]
    if (!label) return
    flatten([data[field]]).filter(isString).forEach((msg) => messages.push(`${label}: ${msg}`))
  })
  return messages.length ? messages.join(' ') : null
}

/**
 * STY-730: the credit form used to reset before the save resolved, and the
 * save swallowed errors, so a rejected credit silently erased what the vendor
 * typed. Reset only after success; on failure keep the input and say why.
 */
export function submitCredit (save, values, { resetForm, setStatus, setSubmitting }) {
  setSubmitting(true)
  setStatus({ error: null })
  return Promise.resolve()
    .then(() => save(values))
    .then(() => {
      resetForm()
      setSubmitting(false)
      return true
    })
    .catch((error) => {
      const detail = fieldMessages(error)
      setStatus({ error: detail ? `${CREDIT_SAVE_FAILED} ${detail}` : CREDIT_SAVE_FAILED })
      setSubmitting(false)
      return false
    })
}
